import { Component, Input, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuditTrail } from '@features/fleets/models/audit-trail.model';
import { SharedApiService } from '@shared-features/services/shared-api.service';
import { BaseComponent } from '@shared/components/base-component/base.component';
import { AuditTrailActions } from "@shared-features/enums/audit-trail-actions.enum";
import { AuditActionType } from "@shared-features/enums/audit-action-type.enum";
import { AuditTrailsDateRangeType } from "@shared-features/enums/audit-trails-date-range-type.enum";
import { takeUntil } from 'rxjs/operators';
import { IconType } from "@shared/enums/icon-type.enum";

@Component({
  selector: 'app-audit-trail',
  templateUrl: './audit-trail.component.html',
  styleUrls: ['./audit-trail.component.scss'],
})
export class AuditTrailComponent extends BaseComponent {
  @Input() title: string;
  @Input() actionType: AuditActionType;
  @Input() shipmentId
  AuditTrailsDateRangeType = AuditTrailsDateRangeType;
  oldJson = { };
  logs: AuditTrail[] = [];
  currentRowIndex: number;

  protected readonly AuditTrailActions = AuditTrailActions;
  protected readonly IconType = IconType;

  constructor(
    
    private sharedApiService: SharedApiService,
    private activatedRoute: ActivatedRoute
  ) {
    super();
  }

  ngOnChanges({ actionType }: SimpleChanges): void {
    if (actionType && actionType.currentValue !== actionType.previousValue) {
      this.getAuditTrails(AuditTrailsDateRangeType.Today);
    }
  }

  getAuditTrails(dateRange: AuditTrailsDateRangeType) {
    this.load(
      this.sharedApiService.getAuditTrails({
        objectId: this.activatedRoute.snapshot.params.id || this.shipmentId,
        actionType: this.actionType,
        dateRange,
      })
    )
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: AuditTrail[]) => {
        this.logs = res;
        if (dateRange === AuditTrailsDateRangeType.Today) {
          this.oldJson = this.logs[0]?.oldJson || {};
          this.currentRowIndex = 0;
        } else {
          this.oldJson = {};
          this.currentRowIndex = null;
        }
      });
  }

  get isOldJsonEmpty(): boolean {
    return !(this.oldJson && Object.keys(this.oldJson).length !== 0);
  }

}
